import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useSKspListQuery, useSKspjdListQuery } from '../../store/DianShangYeWuApi';
function IncomeNodeEdit(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useSKspListQuery({ddsr_sp_ddsr_id:props.ddsr_id},{skip:!props.ddsr_id})
    const {data:spjdData, isSuccess:spjdIsSuccess} = useSKspjdListQuery({
        ddsr_spjd_qy_id:props.qy_id,
        ddsr_spjd_bm_id:props.ddsr_bm_id,
        ddsr_spjd_zflx:props.ddsr_zflx
    },{skip:!props.ddsr_bm_id || !props.ddsr_zflx,refetchOnMountOrArgChange:true});
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            const sortedData = [...data.Result].sort((a, b) => {
                return a.ddsr_sp_jd_xuhao - b.ddsr_sp_jd_xuhao;
            })
            const arr = sortedData.map((item) => ({
                title:<span style={(item.ddsr_sp_state==='3' || item.ddsr_sp_state==='4' || item.ddsr_sp_state==='5' || item.ddsr_sp_state==='6') ? {fontSize:"14px",fontWeight:"bold",color:'#000'} : {fontSize:"14px",fontWeight:"bold",}}>{item.ddsr_sp_jd_name}</span>       ,
                content:<Space orientation='vertical' size={1}>
                             <span>
                                {(item.ddsr_sp_state==='3' && item.ddsr_sp_jd_name==='抄送') && <span style={{color:"#000"}}>未读：</span>}
                                {(item.ddsr_sp_state==='3' && item.ddsr_sp_jd_name==='审批') && <span style={{color:"green"}}>已同意{item.ddsr_sp_content? '：'+item.ddsr_sp_content :''}</span>}
                                {(item.ddsr_sp_state==='4' && item.ddsr_sp_jd_name==='审批') && <span style={{color:"red",fontWeight:"bold"}}>已驳回{item.ddsr_sp_content? '：'+item.ddsr_sp_content :''}</span>}
                            </span>
                            <span style={(item.ddsr_sp_state==='3' || item.ddsr_sp_state==='4' || item.ddsr_sp_state==='5') ? {color:'#000'} : {}}>{item.ddsr_sp_yh_name} {item.ddsr_sp_state_time} </span>
                        </Space>,
            }))
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"12px"}}>{props.ddsr_uname} {props.ddsr_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"12px"}}>{props.ddsr_uname} {props.ddsr_state_time}</span>,
            },...arr]);
        }else{
            if(spjdIsSuccess && spjdData.Status === 'success'){
                
                const arr = spjdData.Result.map((item) => {
                    const {ddsr_spjd_name,ddsr_spjd_yh_name} = item;
                    return {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{ddsr_spjd_name}</span>       ,
                        content:<span style={{fontSize:"12px"}}>{ddsr_spjd_yh_name}</span>,
                    }
                })
                const sortedData = arr.sort((a, b) => {
                    return a.ddsr_spjd_xuhao - b.ddsr_spjd_xuhao;
                })
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"12px"}}>{props.ddsr_uname} {props.ddsr_ctime}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"12px"}}>{props.ddsr_uname}{props.ddsr_state_time}</span>,
                },...sortedData]);
            }else{
                setItems([]);
            }
        }
        
        
    },[data, isSuccess,spjdData, spjdIsSuccess,props])
    return (
        <Steps 
            items={items} 
            current={1} 
            size="small" 
            titlePlacement="vertical"
        />
    )
}

export default IncomeNodeEdit